import { LoadingIndicator, RelativeContainer } from "@components";
import { useFetchedData, useServices } from "@hooks";
import { User, ModuleSetting } from "@models";
import React, { useCallback } from "react";
import ExpandedUserDetails from "./ExpandedUserDetails";

type Props = {
	user: User;
	moduleSettings: ModuleSetting[];
};

export default function ExpandedUserDetailsRow(props: Props) {
	const { user, moduleSettings } = props;
	const { userService } = useServices();

	const fetchUserStatus = useCallback(
		() => userService.getUserAuthenticationStatus(user.userId),
		[userService, user.userId]
	);

	const [userStatusQuery] = useFetchedData(fetchUserStatus);

	if (userStatusQuery.state === "success") {
		return (
			<ExpandedUserDetails
				user={user}
				moduleSettings={moduleSettings}
				userStatus={userStatusQuery.data.userStatus}
			/>
		);
	} else {
		return (
			<RelativeContainer>
				<LoadingIndicator />
			</RelativeContainer>
		);
	}
}
